<template>
	<div v-bind="$attrs" v-on="$listeners" class="display-flex flex-column">
		<slot />
	</div>
</template>
<script>
export default {
	// eslint-disable vue/no-reserved-component-names, vue/multi-word-component-names
	name: 'Column', // Todo: remove change from Col to Column (or anything else that isn't an html attribute)
};
</script>
